module.exports = "mutation DeleteReminder($id: ID!) {\n  deleteReminder(id: $id) {\n    deleted\n  }\n}\n"